import { render } from "./Benutzerverwaltung.vue?vue&type=template&id=2814cde2&scoped=true"
import script from "./Benutzerverwaltung.vue?vue&type=script&lang=js"
export * from "./Benutzerverwaltung.vue?vue&type=script&lang=js"

import "./Benutzerverwaltung.vue?vue&type=style&index=0&id=2814cde2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2814cde2"]])

export default __exports__